import {makeStyles} from "tss-react/mui";

export const useStyles = makeStyles()((theme) => {
  return {
    drawerBtn: {
      padding: '20px 25px',
      position: 'fixed',
      zIndex: 999,
      border: 0,
      background: theme.palette.secondary.main,
      top: '50%',
      WebkitTransform: 'rotate(-90deg)',
      borderRadius: '4px 4px 0 0!important',
      right: '-50px',
      width: 'auto',
      minWidth: 'auto!important',
      height: 'auto',
      fontSize: '18px',
      textTransform: 'uppercase',
      display: 'inline-block',
      cursor: 'pointer',
      color: '#000',
      [theme.breakpoints.down('sm')]: {
        width: 'fit-content!important',
        left: 15,
        bottom: 15,
        zIndex: 99,
        whiteSpace: 'normal',
        top: 'inherit!important',
        transform: 'initial!important',
        padding: '14px!important',
        writingMode: 'initial'
      },
      '&:hover': {
        background: theme.palette.secondary.main,
      },
    },
    root: {
      '& .MuiPaper-root': {
        width: 470,
        backgroundColor: theme.palette.secondary.main,
        [theme.breakpoints.down('sm')]: {
          padding: '0',
          width: '-webkit-fill-available',
          backgroundColor: theme.palette.secondary.main
        }
      },
      '#fieldContent': {
        backgroundColor: '#FFF!important',
      },
      '#promoCode': {
        width: '100%!important',
        maxWidth: '100%!important',
        '& .MuiTextField-root': {
          backgroundColor: '#FFF!important',
          '& .MuiInputBase-root': {
            width: '100%',
            paddingLeft: '0!important'
          }
        }
      },
      h6: {
        fontFamily: theme.typography.h6.fontFamily + '!important'
      }
    },
  };
});
